"use client";

import { cn } from "utils";
import { TrackersSetupTrackerRow } from "./TrackersSetupTrackerRow";
import type { TrackersSetupTrackerItem } from "./types";

interface TrackersSetupTrackerListProps {
  trackers: TrackersSetupTrackerItem[];
  className?: string;
}

export const TrackersSetupTrackerList: React.FC<
  TrackersSetupTrackerListProps
> = ({ trackers, className }) => (
  <div
    className={cn(
      "flex flex-col overflow-hidden rounded-2xl bg-background_solid_neutral_primary",
      className,
    )}
    data-testid="trackers-setup-tracker-list-view"
  >
    {trackers.map((item, index) => (
      <div key={item.id} className="contents">
        {index > 0 ? (
          <div
            className="h-px w-full bg-border_white_transparent10"
            aria-hidden
          />
        ) : null}
        <TrackersSetupTrackerRow item={item} index={index} />
      </div>
    ))}
  </div>
);
